import React from 'react';

import ButtonBase from 'xgimi-ui/mui/material/ButtonBase';
import Base from 'xgimi-ui/BaseComponent';

import s from './.module.scss';

interface Props {
  // 取消
  onCancel?: () => void;
  // 取消文本
  cancelText?: string;
  // 确认
  onConfirm?: () => void;
  // 确认文本
  confirmText?: string;
}

interface State {

}

/**
 * Confirm组件
 */
class Confirm extends Base<Props, State> {
  render(): React.ReactNode {
    return (
      <div className={s.container}>
        <div className={s.content}>{this.props.children}</div>
        <div className={s.buttonArea}>
          <ButtonBase className={s.cancel} onClick={this.props.onCancel} disableRipple={true}>
            <span className={s.cancelLabel}>{this.props.cancelText}</span>
          </ButtonBase>
          <div className={s.divider} />
          <ButtonBase className={s.confirm} onClick={this.props.onConfirm} disableRipple={true}>
            <span className={s.confirmLabel}>{this.props.confirmText}</span>
          </ButtonBase>
        </div>
      </div>
    );
  }
}

export default Confirm;
